module.exports = __webpack_public_path__ + "static/media/promo-banner.05776d57.webp";